<p-dialog
  [visible]="visible()"
  (visibleChange)="!$event && close()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ width: '720px', maxWidth: 'calc(100vw - 32px)' }"
>
  <ng-template pTemplate="header">
    <div class="flex min-w-0 flex-col gap-0.5">
      <h2
        class="flex items-center gap-2 text-heading-4 font-semibold text-primary-900"
      >
        <lucide-icon [name]="icon()" [size]="20" class="text-primary-600" />
        {{ title() }}
      </h2>
      @if (data()?.groundRoutes; as routes) {
        <p class="text-paragraph-s-reg text-greyscale-600">
          {{
            "reductionTips.dialog.confirmedIntro"
              | transloco
                : { origin: routes.origin, destination: routes.destination }
          }}
          {{ basis() }}
        </p>
      }
    </div>
  </ng-template>

  @if (data(); as tipData) {
    <div class="flex flex-col gap-2.5">
      <!-- The flight, as the yardstick the itineraries below are read against. -->
      <div
        class="flex flex-wrap items-center gap-x-3 gap-y-1 rounded-lg bg-greyscale-50 px-3.5 py-2.5 text-paragraph-s-reg text-greyscale-800"
      >
        <lucide-icon name="plane" [size]="16" />
        <span>{{
          "reductionTips.transportAlternative.plane" | transloco
        }}</span>
        @if (tipData.flightRoute) {
          <span class="text-paragraph-xs-reg tabular-nums text-greyscale-600">
            {{ tipData.flightRoute }}
          </span>
        }
        <span class="ml-auto font-semibold tabular-nums text-greyscale-900">
          {{ flightEmissions() | formatCO2e }}
        </span>
      </div>

      @for (itinerary of itineraries(); track itinerary.index) {
        <div
          class="rounded-lg border px-3.5 py-3 transition-colors"
          [class]="
            chosenRouteIndex() === itinerary.index
              ? 'border-primary-500 bg-primary-50'
              : 'border-greyscale-200 hover:border-primary-300'
          "
        >
          <!-- The whole summary row labels the radio, so clicking anywhere on
               it picks the itinerary; the legs below stay free to read. -->
          <label
            [for]="'itinerary-' + itinerary.index"
            class="grid cursor-pointer grid-cols-[18px_minmax(0,1fr)_auto] items-center gap-2.5"
          >
            <p-radiobutton
              name="itinerary"
              [value]="itinerary.index"
              [ngModel]="chosenRouteIndex()"
              (ngModelChange)="chosenRouteIndex.set($event)"
              [inputId]="'itinerary-' + itinerary.index"
            />
            <span
              class="flex flex-wrap items-center gap-x-2 gap-y-1 text-paragraph-s-reg font-semibold text-primary-900"
            >
              {{ itinerary.label }}
              <span
                class="text-paragraph-xs-reg font-normal tabular-nums text-greyscale-600"
              >
                {{ itinerary.route.durationHours | durationFormat }} ·
                {{ tipsService.changesLabel(itinerary.route) }}
              </span>
              @if (itinerary.index === 0 && itineraries().length > 1) {
                <span
                  class="rounded-full bg-primary-100 px-2 text-paragraph-xs-reg font-semibold text-primary-700"
                >
                  {{ "reductionTips.dialog.fastest" | transloco }}
                </span>
              }
            </span>
            <span class="text-right tabular-nums">
              <span
                class="block text-paragraph-s-reg font-semibold text-greyscale-900"
              >
                {{ itinerary.emissions | formatCO2e }}
              </span>
              <span
                class="block text-paragraph-xs-reg font-semibold text-validation-600"
              >
                −{{ itinerary.savingsPercent }}%
              </span>
            </span>
          </label>

          <app-route-legs class="ml-7 mt-2.5" [route]="itinerary.route" />
        </div>
      }
    </div>
  }

  <ng-template pTemplate="footer">
    <div class="flex w-full flex-wrap items-center justify-end gap-3">
      <p
        class="min-w-[220px] flex-1 text-left text-paragraph-xs-reg text-greyscale-500"
      >
        {{ "reductionTips.route.disclaimer" | transloco }}
      </p>
      <p-button
        [label]="'common.close' | transloco"
        severity="secondary"
        [text]="true"
        size="small"
        (onClick)="close()"
      />
      <p-button
        [label]="'reductionTips.dialog.simulate' | transloco"
        size="small"
        (onClick)="confirm()"
      />
    </div>
  </ng-template>
</p-dialog>
